import { IQrCode } from "../../../components/admin/models";
import QRCodeReact from "react-qr-code";
import { CollapsiblePanel } from "./collapsiblePanel";
import { ObjectForm } from "./objectForm";
import { useState } from "react";

interface IQRCodePanelProps {
  currentQR: IQrCode;
  saveQREvent: (name: string) => void;
  cancelQREvent: () => void;
  isSaving?: boolean;
  updateQRLongitude: (value: number) => void;
  updateQRLatitude: (value: number) => void;
  updateQRAltitude: (value: number) => void;
  updateQRHeading: (value: number) => void;
}

export const QRCodePanel = (props: IQRCodePanelProps) => {
  const {
    currentQR,
    saveQREvent,
    cancelQREvent,
    updateQRLongitude,
    updateQRLatitude,
    updateQRAltitude,
    updateQRHeading,
    isSaving,
  } = props;

  const [showQRSavingForm, setShowQRSavingForm] = useState(false);

  return (
    <>
      <CollapsiblePanel header="QR Code" isPanelOpen={true}>
        <div>
          <div className="grid grid-cols-8 gap-4">
            <div className="font-medium col-span-1">ID</div>
            <div className="flex items-center text-xs items-center col-span-7">
              {currentQR.id}
            </div>
          </div>
          <h4>Longitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.longitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(-0.00001)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(-0.000001)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(0.000001)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(0.00001)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Latitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.latitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(-0.00001)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(-0.000001)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(0.000001)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(0.00001)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Altitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.altitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(-1)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(-0.1)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(0.1)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(1)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Heading</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.heading}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(-10)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(-1)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(1)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(10)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>QR Code</h4>
          <div className="flex flex-col items-center justify-center">
            <p className="text-xs underline break-words w-full text-center">
              {`{https://www.foundat.com/app,"ast":0,"la":${currentQR.latitude},"lo":${currentQR.longitude},"a":${currentQR.altitude},"h":${currentQR.heading}}`}
            </p>
            <QRCodeReact
              size={180}
              value={`{https://www.foundat.com/app,"ast":0,"la":${currentQR.latitude},"lo":${currentQR.longitude},"a":${currentQR.altitude},"h":${currentQR.heading}}`}
              viewBox={`0 0 256 256`}
              className="w-3/5"
            />
          </div>

          <div className="flex justify-center space-x-2 mt-4">
            <button
              className="px-4 py-2 hover:bg-gray-100"
              type="button"
              onClick={() => cancelQREvent()}
            >
              CANCEL
            </button>
            <button
              className="px-4 py-2 border rounded-lg bg-[#2fe9ff] text-white hover:bg-[#2fe9ff]-600"
              type="button"
              onClick={() => {
                setShowQRSavingForm(true);
              }}
            >
              SAVE QR
            </button>
          </div>
        </div>
      </CollapsiblePanel>
      <ObjectForm
        onSave={saveQREvent}
        onCancel={cancelQREvent}
        show={showQRSavingForm}
        isSaving={isSaving}
      />
    </>
  );
};
